import React from "react";
import Contactform from "./Contactform";

export default function Careers(){
    return(
        <>
        <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Careers</h1>

                </div>

            </div>
            <Contactform/>
        
        </>
    )
}